import { render, staticRenderFns } from "./ocrRule.vue?vue&type=template&id=237cf016&scoped=true&"
import script from "./ocrRule.vue?vue&type=script&lang=js&"
export * from "./ocrRule.vue?vue&type=script&lang=js&"
import style0 from "./ocrRule.vue?vue&type=style&index=0&id=237cf016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237cf016",
  null
  
)

component.options.__file = "ocrRule.vue"
export default component.exports